<template>
  <item-form schema="new" title="NUEVO INCONVENIENTE" icon="mdi-account-question-outline"/>
</template>

<script>
import ItemForm from "../../components/Forms/ItemForm.vue";

export default {
  components: { ItemForm },
};
</script>

<style></style>
